import { render, staticRenderFns } from "./EmailUserDetails.vue?vue&type=template&id=027146d5"
import script from "./EmailUserDetails.vue?vue&type=script&lang=js"
export * from "./EmailUserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports